var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`eyedropper ${_vm.selected ? 'selected' : ''} `},[_c('i',{staticClass:"mdi mdi-eyedropper",on:{"click":_vm.selectColor}})])
}
var staticRenderFns = []

export { render, staticRenderFns }